import React from 'react';
export var riskTypeMap = function () {
    return {
        costControl: i18n.get('费标'),
        budget: i18n.get('预算')
    };
};
export var riskColorMap = {
    costControl: {
        warn: 'orange-bg',
        error: 'red-bg'
    },
    budget: {
        yellow: 'orange-bg',
        red: 'red-bg',
        blue: 'blue-bg',
    }
};
var costControlComponent = function (risk) {
    var _a;
    var riskDesc = risk.ruleDetail ? risk.ruleDetail.split('\n') : [];
    return (React.createElement("div", { className: "cost-control-item" },
        risk.ruleDetail ? React.createElement("div", { className: "risk-rule-detail" }, riskDesc === null || riskDesc === void 0 ? void 0 : riskDesc.map(function (l) { return React.createElement("div", { style: { minHeight: 8 } }, i18n.get(l)); })) : null,
        React.createElement("div", { className: "risk-messages" }, (_a = risk.messages) === null || _a === void 0 ? void 0 : _a.map(function (msg, index) {
            var _a;
            return (React.createElement("div", { className: "risk-messages-item", key: msg }, ((_a = risk.messages) === null || _a === void 0 ? void 0 : _a.length) === 1 ? i18n.get(msg) : i18n.get(index + 1 + "\u3001" + msg)));
        }))));
};
var budgetComponent = function (item) {
    var _a;
    if ((_a = item.nodes) === null || _a === void 0 ? void 0 : _a.length) {
        return (React.createElement(React.Fragment, null, item.nodes.map(function (el) {
            var isShowContent = el.budgetMoney !== null || el.userdMoney !== null || el.remainMoney !== null || el.budgetPercent !== null;
            return (React.createElement("div", { className: "budget-risk-item risk-item-content" },
                React.createElement("div", { className: "budget-risk-item-name" },
                    React.createElement("div", null, el.nodeName),
                    React.createElement("div", null,
                        i18n.get('超标{__k0}时，', { __k0: el.controlPercent }),
                        el.control)),
                isShowContent && (React.createElement("div", { className: "budget-risk-item-content" },
                    el.budgetMoney !== null && (React.createElement("div", null,
                        React.createElement("span", { className: 'budget-content-label' }, i18n.get('预算金额') + '：'),
                        React.createElement("span", { className: 'budget-content-value' },
                            item.symbol,
                            el.budgetMoney))),
                    el.userdMoney !== null && (React.createElement("div", null,
                        React.createElement("span", { className: 'budget-content-label' }, i18n.get('已用金额') + '：'),
                        React.createElement("span", { className: 'budget-content-value' },
                            item.symbol,
                            el.userdMoney))),
                    el.remainMoney !== null && (React.createElement("div", null,
                        React.createElement("span", { className: 'budget-content-label' }, i18n.get('预算余额') + '：'),
                        React.createElement("span", { className: 'budget-content-value' },
                            item.symbol,
                            el.remainMoney))),
                    el.budgetPercent !== null && (React.createElement("div", null,
                        React.createElement("span", { className: 'budget-content-label' }, i18n.get('预算执行比例') + '：'),
                        React.createElement("span", { className: 'budget-content-value' }, el.budgetPercent)))))));
        })));
    }
    return null;
};
export function flattenObject(obj) {
    var result = [];
    function recurse(current) {
        if (Array.isArray(current)) {
            result = result.concat(current);
        }
        else if (typeof current === 'object' && current !== null) {
            for (var key in current) {
                if (current.hasOwnProperty(key)) {
                    recurse(current[key]);
                }
            }
        }
    }
    recurse(obj);
    return result;
}
export var getRiskComponent = function () {
    return {
        costControl: costControlComponent,
        budget: budgetComponent
    };
};
